import { Injectable, Inject } from "@angular/core";
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { environment } from "../../environments/environment";
import * as jwt_decode from "jwt-decode";
import { CryptographyService } from "./cryptography.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate, CanActivateChild {
  constructor(
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private cryptographyService: CryptographyService,
    private oauthService: OAuthService,
    private router: Router
  ) {}

  expirationTimeInMilliseconds: number;
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // alert(state.url);
    // return true
    if (environment.skipAuthentication) {
      return true;
    }

    localStorage.setItem("redirectUrl", state.url);

    
    // Check if we have a valid token
    if (!this.oauthService.hasValidAccessToken()) {
      void 0;
      this.oauthService.initImplicitFlow();
      return false;
    }

    // If we have a token but no user data, check if user is authenticated
    const isAuthenticated = this.storage.get("isAuthenticatedUser")
      ? this.cryptographyService.decryptData(this.storage.get("isAuthenticatedUser"))
      : this.storage.get("isAuthenticatedUser");

    if (!isAuthenticated) {
      void 0;
    }

    return true;
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.canActivate(childRoute, state);
  }
}
